
import { Button } from "@/components/ui/button";
import { Search, Trash } from "lucide-react";

interface MemoryTableHeaderProps {
  pageTitle: string;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedCount: number;
  onBulkDelete: () => void;
}

const MemoryTableHeader = ({ 
  pageTitle, 
  searchTerm, 
  onSearchChange, 
  selectedCount, 
  onBulkDelete 
}: MemoryTableHeaderProps) => {
  return (
    <div className="flex items-center justify-between flex-wrap gap-4 p-6 bg-card border border-border rounded-2xl shadow-lg backdrop-blur-sm">
      <h2 className="text-2xl font-semibold text-foreground">{pageTitle}</h2>
      <div className="flex items-center gap-3">
        <div className="flex items-center bg-input border border-border rounded-xl px-4 py-2 w-64 transition-all focus-within:ring-2 focus-within:ring-primary/20 focus-within:border-primary/50">
          <Search className="h-4 w-4 mr-2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search memories..."
            className="border-none bg-transparent focus:outline-none w-full text-foreground placeholder:text-muted-foreground"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        {selectedCount > 0 && (
          <Button 
            variant="destructive" 
            size="sm" 
            onClick={onBulkDelete}
            className="whitespace-nowrap shadow-lg"
          >
            <Trash className="h-4 w-4 mr-2" />
            Delete Selected ({selectedCount})
          </Button>
        )}
      </div>
    </div>
  );
};

export default MemoryTableHeader;
